import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { setOfflineCacheIdentity } from './offlineTripCache';
import { safeAuthNextPath } from './authRedirect';

export async function clearAuthToken(): Promise<void> {
  await setOfflineCacheIdentity(null);
  await supabase.auth.signOut();
  window.dispatchEvent(new Event('webapp-auth-changed'));
  window.location.assign('/');
}

export function loginPath(nextPath: string): string {
  return `/login?next=${encodeURIComponent(safeAuthNextPath(nextPath, '/'))}`;
}

export function useStoredAuthToken(): string {
  const [token, setToken] = useState('');
  useEffect(() => {
    void supabase.auth.getSession().then(async ({ data }) => {
      if (data.session?.user.id) await setOfflineCacheIdentity(data.session.user.id);
      setToken(data.session?.access_token ?? '');
    });
    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session?.user.id) {
        setToken('');
        return;
      }
      void setOfflineCacheIdentity(session.user.id).then(() => setToken(session.access_token ?? ''));
    });
    return () => data.subscription.unsubscribe();
  }, []);
  return token;
}

export function useRequireAuth(): { token: string; checking: boolean } {
  const token = useStoredAuthToken();
  const [checking, setChecking] = useState(true);
  useEffect(() => {
    void supabase.auth.getSession().then(({ data }) => {
      setChecking(false);
      if (!data.session) window.location.replace(loginPath(`${window.location.pathname}${window.location.search}`));
    });
  }, []);
  return { token, checking };
}
